import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// 401 -> redirect to login. 403 handled per-page.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const ROLE_LABEL = {
  CEO_ADMIN: "CEO / Admin",
  PRODUCTION_MANAGER: "Production Manager",
  PRODUCTION_SUPERVISOR: "Supervisor",
  QC: "QC / QA",
  STORES: "Stores",
  PURCHASE: "Purchase",
  SALES: "Sales",
  MAINTENANCE: "Maintenance",
  ACCOUNTS: "Accounts",
  OPERATOR: "Operator",
};

export const STATUS_TO_PILL = (s) => {
  const map = {
    RUNNING: "pill-running", IDLE: "pill-idle", BREAKDOWN: "pill-breakdown",
    SETUP: "pill-setup", MAINTENANCE: "pill-maintenance",
    APPROVED: "pill-approved", REJECTED: "pill-rejected", PENDING: "pill-pending",
    HOLD: "pill-hold", QC_HOLD: "pill-hold", PLANNED: "pill-planned",
    RELEASED: "pill-released", QC_RELEASED: "pill-released",
    COMPLETED: "pill-completed", CLOSED: "pill-closed",
    PAUSED: "pill-paused", CANCELLED: "pill-cancelled", QUARANTINE: "pill-quarantine",
  };
  return map[s] || "pill-idle";
};
